import axios from 'axios'
import { Message, Loading } from 'element-ui' // 假设使用 Element UI
import store from '@/store'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api',  // 使用代理路径
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})
// 加载动画实例
let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示加载动画
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 如果有token，添加到请求头
    const token = localStorage.getItem('token');
    // console.log("store",store)
    if (token) {
      config.headers['token'] = `${token}`
    }
    // 固定为管理后台的请求
    config.headers['X-Client-Type'] = 'UTM'
    return config
  },
  error => {
    // 关闭加载动画
    if (loadingInstance) {
      loadingInstance.close()
    }

    // 请求错误处理
    console.error('请求错误:', error)
    Message.error('请求发生错误，请稍后重试')
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 关闭加载动画
    if (loadingInstance) {
      loadingInstance.close()
    }

    // 如果是 blob 类型，返回完整 response 对象以便获取 headers
    if (response.config.responseType === 'blob') {
      return response
    }
    
    const res = response.data
    return res
    // 根据后端约定的状态码处理
    // if (res.code !== 200) {
    //   // 错误提示
    //   Message.error(res.msg || '操作失败')

    //   处理特殊状态码
    //   if (res.code === 401) {
    //     // 未授权，需要重新登录
    //     store.dispatch('user/logout').then(() => {
    //       router.push('/login')
    //     })
    //   }

    //   return Promise.reject(new Error(res.msg || 'Error'))
    // } else {
    //   // 请求成功
    //   return res
    // }
  },
  error => {
    // 关闭加载动画
    if (loadingInstance) {
      loadingInstance.close()
    }

    // 处理网络错误
    console.error('响应错误:', error)

    if (error.response) {
      // 服务器返回错误
      const status = error.response.status
      switch (status) {
        case 400:
          Message.error(error.response.data.message)
          break
        case 401:
          Message.error('登录已过期，请重新登录')
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          router.push('/login')
          // store.dispatch('user/logout').then(() => {
          //   router.push('/login')
          // })
          break
        case 403:
          Message.error('没有权限执行此操作')
          break
        case 404:
          Message.error('请求的资源不存在')
          break
        case 500:
          Message.error(error.response.data.message)
          break
        default:
          Message.error(`请求错误: ${status}`)
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      Message.error('网络连接异常，请检查网络')
    } else {
      // 其他错误
      Message.error('请求发生错误，请稍后重试')
    }

    return Promise.reject(error)
  }
)

export default service
